import { ItemSource, ItemWithMetaData } from "../api/Items";
import { PostTypes } from "../api/Items";

/**
 * Gets the display text for a post type
 * @param post The post to get the display type for
 * @returns The display text for the post type
 */
export function getDisplayPostTypeText(post: ItemWithMetaData): string {
  const postType = post.item.content?.type || "";
  const reactionType = post.item.content?.reaction_type || "";

  // If there's a reaction_type, use it directly with first letter capitalized
  if (reactionType) {
    return reactionType.charAt(0).toUpperCase() + reactionType.slice(1);
  }

  // Standard post types
  switch (postType) {
    case PostTypes.Original:
      return "Posted";
    case PostTypes.Shared:
      return "Shared";
    case PostTypes.Liked:
      return "Liked";
    default:
      // For any other type, use the type as is with first letter capitalized
      return postType
        ? postType.charAt(0).toUpperCase() + postType.slice(1).toLowerCase()
        : "Posted";
  }
}

type SourceNameDisplayMap = {
  [key: string]: string;
};

function buildDisplayNameMap(sources: ItemSource[]): SourceNameDisplayMap {
  const nameMapping: SourceNameDisplayMap = {};
  for (const source of sources) {
    nameMapping[source.name.toLocaleLowerCase()] =
      source.display || source.name;
  }
  return nameMapping;
}

export function getSourceDisplayName(source: string): string {
  try {
    const storedData = sessionStorage.getItem("itemSources") ?? "";
    const mapping: SourceNameDisplayMap = buildDisplayNameMap(
      JSON.parse(storedData)
    );
    return mapping[source.toLocaleLowerCase()] ?? source;
  } catch (ex) {
    return source;
  }
}
